

export const updateOrderReduce = (chain, _,{_payload}) => chain.set('order',_payload)
export const deleteItemReduce = (chain, _, {_payload}) => chain.unset(_payload).filter('order',id => id!==_payload)

export const addItemReduce = (chain, success, {index,_payload}, idKey = 'id') =>{
  const payloadWitJson = {..._payload,...(success || {})};
  return chain.set(payloadWitJson[idKey],payloadWitJson)
    .update('order',order => index !== undefined ? [...order.slice(0, index), payloadWitJson[idKey], ...order.slice(index)] : order.concat([payloadWitJson[idKey]]))
};
export const updateItemReduce = (chain, _,{_payload}) => chain.set(_payload.id, _payload)
export const updateMergeReduce = (chain, _,{_payload}) => chain.assign(_payload);

export function arrToMap(arr, key="id") {
  let map = {};
  for (let i = 0; i < arr.length; i++) {
    map[arr[i][key]] = arr[i];
  }
  return map;
}


// WEBPACK FOOTER //
// ./~/report-components/src/reducers/commonReducers.js